/// <amd-module name="Pipeline/Analytics/Common/PerfScenarios" />
export const Area = "Build";
export const PipelinesAnalyticsHub = "Pipelines.Analytics.Hub";
export const PipelinesDurationHub = "Pipelines.Duration.Hub";
